module.exports = __webpack_public_path__ + "static/media/koolicar-pin-small.e7de6220.svg";